import React, { useEffect, useState } from 'react'
import { useStore, useDispatch } from 'react-redux'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import { toast } from '../CommonComponents/ToastComponent/toast'
import { Table, Checkbox } from 'rsuite'
import { useHistory, Link } from 'react-router-dom'
import { getMasterSuppliersForQA, getMasterSuppliersCountForQA } from '../../redux/actions/vendor'
import { getAbbreviatedState } from '../../services/helper'

const { Column, HeaderCell, Cell, Pagination } = Table

export const LinkCell = ({ rowData, dataKey, onClick, ...props }) => {
  let bgColorClass = rowData[dataKey] === 'Approved' ? 'bg-green' : rowData[dataKey] === 'Rejected' ? 'bg-red' : rowData[dataKey] === 'In Calls' ? 'bg-blue' : 'bg-yellow'
  let stateCode = ''
  if (dataKey === 'state') {
    if (rowData?.abbreviatedState === null) {
      stateCode = getAbbreviatedState(rowData?.abbreviatedState, rowData?.state)
    } else {
      stateCode = rowData?.abbreviatedState
    }
  }
  return (
    <Cell {...props} className="table-link">
      {dataKey === 'state' ?
        stateCode
        :
        dataKey === 'supplierQARole' ?
          <h5 style={{ width: '60px' }} className={`btn text-white ${bgColorClass}`}>
            {rowData[dataKey]}
          </h5>
          :
          <Link to={`/suppliers/${rowData.id}`} target="_blank">{rowData[dataKey]}</Link>
      }
    </Cell>
  )
}

export const BoolCell = ({ rowData, dataKey, onClick, ...props }) => {
  return (
    <Cell {...props}>
      {dataKey === 'isAcceptAchPayments' || dataKey === 'isAcceptCheckPayments' ? // accept check and ach payment cells
        rowData?.payment?.[dataKey] === null ? 'Unknown' : rowData?.payment?.[dataKey] ? 'Yes' : 'No'
        :
        rowData?.cardAcceptance?.[dataKey] === null ? 'Unknown' : rowData?.cardAcceptance?.[dataKey] ? 'Yes' : 'No'
      }
    </Cell>
  )
}

export const SelectorCell = ({ rowData, dataKey, onChange, selectedMasterIds, onSelectMaster, onShowChildren, ...props }) => {
  const isSelected = selectedMasterIds && selectedMasterIds.length > 0 ? selectedMasterIds.findIndex(id => id === rowData.id) !== -1 : false
  return (
    <Cell {...props} className="table-action" fixed>
      <div className="button container">
        {
          isSelected ? (
            <button type="button" className="btn btn-green select h-100" style={{ width: "36%" }} onClick={() => onSelectMaster(rowData.id)}>DE SELECT</button>
          ) : (
            <button type="button" className="btn btn-green select h-100" style={{ width: "36%" }} onClick={() => onSelectMaster(rowData.id)}>SELECT</button>
          )
        }
        <button type="button" className="btn btn-gray children h-100" onClick={() => onShowChildren(rowData.id)}>SHOW CHILDREN</button>
      </div>
    </Cell>
  )
}

const QualityMasterSuppliersComponent = ({ tableData, isLoading = false, onApproveSuppliers, onRejectSuppliers, selectedMasterIds, onSelectChildren, onSelectMaster, masterSuppliers, onGoToMasterDetail, totalMasterRecords, isQANoteSubmitted, updateIsQANoteSubmitted, searchList, searchBoolean, onConfirmAndReenable }) => {
  const store = useStore().getState()
  const dispatch = useDispatch()
  const {
    app: { masterSupplierColumns, masterSupplierColumnsRight }
  } = store

  const history = useHistory()
  useEffect(() => {
    history.push('/qa/')
  }, [])



  const [checkedKeys, setCheckedKeys] = useState([])
  const [checkedSuppliers, setCheckedSuppliers] = useState([])

  const [showPending, setShowPending] = useState(true)
  const [showApproved, setShowApproved] = useState(false)
  const [showRejected, setShowRejected] = useState(false)

  const [sortColumn, setSortColumn] = useState('id')
  const [sortType, setSortType] = useState('asc')
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)
  const [paginatedTableData, setPaginatedTableData] = useState([])
  const [totalTableRecords, setTableTotalRecords] = useState(0)

  useEffect(() => {
    if (!(tableData && tableData?.length > 0)) {
      setPaginatedTableData([])
      setTableTotalRecords(0)
      return
    }
    setTableTotalRecords(totalMasterRecords)
    setPaginatedTableData(tableData)
    if (isQANoteSubmitted) {
      setCheckedKeys([])
      setCheckedSuppliers([])
      updateIsQANoteSubmitted()
    }
  }, [tableData])

  // add selected master suppliers to search results
  const tmpTableData = tableData ? JSON?.parse(JSON?.stringify(tableData)) : [];
  if (selectedMasterIds || selectedMasterIds.length > 0) {
    selectedMasterIds.forEach(masterId => {
      if (tmpTableData.findIndex(row => row.id === masterId) === -1) {
        tmpTableData.push(masterSuppliers.find(row => row.id === masterId))
      }
    })
  }
  const tableDataWithQA = tmpTableData.map(row => ({
    ...row,
    supplierQARole: row?.supplierQARole ? row?.supplierQARole : 'Pending'
  }))

  const handleShowChildren = (masterId) => {
    if (!selectedMasterIds || selectedMasterIds.length === 0) {
      onSelectChildren([masterId])
      return
    }
    onSelectChildren(selectedMasterIds)
  }

  const handleSelectMaster = (id) => {
    onSelectMaster(id)
  }

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
    setCheckedKeys([]);
    setCheckedSuppliers([]);
  }

  const handleChangePage = (event) => {
    setPage(event)
    setCheckedKeys([]);
    setCheckedSuppliers([]);
  }

  const handleSortTableData = (sortColumn, sortType) => {
    setSortColumn(sortColumn)
    setSortType(sortType)
  }

  const handleClickMaster = (masterId) => {
    onGoToMasterDetail(masterId);
  };

  const masterSupplierColumnLeft = [
    { name: 'suppliername', label: 'Master Supplier' },
    { name: 'address1', label: 'Address 1' },
    { name: 'address2', label: 'Address 2' },
    { name: 'city', label: 'City' },
    { name: 'state', label: 'State' },
    { name: 'zip', label: 'Zip' },
    { name: 'phone', label: 'Phone' },
    { name: 'email', label: 'Email' },
    { name: 'contactDate', label: 'Contact Date' }
  ]

  const masterSupplierColumnRight = [
    { name: 'isAcceptCheckPayments', label: 'Accepts Check' },
    { name: 'isAcceptAchPayments', label: 'Accepts ACH' },
    { name: 'isAcceptAmericanExpress', label: 'Accepts Amex' },
    { name: 'isAcceptVisa', label: 'Accepts Visa' },
    { name: 'isAcceptMasterCard', label: 'Accepts MC' }
  ]

  const headerElementRight = masterSupplierColumnRight.map(h => {
    return (
      <Column
        width={120}
        resizable
        sortable
        key={h.name}
      >
        <HeaderCell>{h.label}</HeaderCell>
        {/* <Cell dataKey={h.name} /> */}
        <BoolCell dataKey={h.name} />
      </Column>
    )
  })

  const headerElement = masterSupplierColumnLeft.map((h, index) => {
    if (index === 0) {
      return (
        <Column
          resizable
          sortable
          key={h.name}
        >
          <HeaderCell>{h.label}</HeaderCell>
          <LinkCell dataKey={h.name} onClick={handleClickMaster} />
        </Column>
      )
    }
    return (
      <Column
        resizable
        sortable
        key={h.name}
      >
        <HeaderCell>{h.label}</HeaderCell>
        {h.name === 'state' ?
          <LinkCell dataKey={h.name} />
          :
          <Cell dataKey={h.name} />
        }
      </Column>
    )
  })

  let checked = false
  let indeterminate = false
  if (checkedKeys && tableData && checkedKeys.length === tableData?.length) {
    checked = true;
  } else if (checkedKeys && checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys && tableData && checkedKeys.length > 0 && checkedKeys.length < tableData?.length) {
    indeterminate = true;
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <Checkbox
        value={rowData[dataKey]}
        onChange={onChange}
        checked={checkedKeys.some(item => item === rowData[dataKey])}
      />
    </Cell>
  )

  const handleCheckAll = (value, checked) => {
    let keys = checked ? tableData?.map(item => item.id) : []
    if (checked) {
      setCheckedSuppliers(tableData)
    } else {
      setCheckedSuppliers([])
    }
    setCheckedKeys(keys)
  }
  const handleCheck = (value, checked) => {
    const nextCheckedKeys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value)
    setCheckedKeys(nextCheckedKeys)
    let tmpCheckedSuppliers = [...checkedSuppliers];
    if (checked) {
      tmpCheckedSuppliers = [...tmpCheckedSuppliers, tableData?.find(row => row.id === value)]
    } else {
      tmpCheckedSuppliers = tmpCheckedSuppliers?.filter(row => row.id !== value)
    }
    setCheckedSuppliers(tmpCheckedSuppliers)
  }

  const handleClickApprove = () => {
    if (!checkedKeys || checkedKeys.length === 0) {
      toast.show({
        title: 'Warning',
        description: 'No supplier selected'
      })
      return
    }
    onApproveSuppliers(checkedKeys, 'master', limit, page, showPending, showApproved, showRejected)
  }

  const handleClickReject = () => {
    if (!checkedKeys || checkedKeys.length === 0) {
      toast.show({
        title: 'Warning',
        description: 'No supplier selected'
      })
      return
    }
    onRejectSuppliers(checkedKeys, 'master', limit, page, showPending, showApproved, showRejected)
  }

  const setPageData = async (searchList = {}) => {
    const data = await dispatch(getMasterSuppliersForQA({
      limit: limit,
      offset: limit * (page - 1),
      pending: showPending,
      approved: showApproved,
      rejected: showRejected,
      searchList
    })).then(res => {
      if (res === undefined) {
        return []
      }
      return res
    })
    return data
  }

  const getTotalSuppliers = async (searchList = {}) => {
    dispatch(getMasterSuppliersCountForQA({
      pending: showPending,
      approved: showApproved,
      rejected: showRejected,
      searchList
    })).then(response => {
      setTableTotalRecords(response?.count)
    })
  }

  useEffect(async () => {
    let filteredData = []
    let tableData = []

    if (Object.keys(searchList).length !== 0) {
      tableData = await setPageData(searchList)
      await getTotalSuppliers(searchList)
    } else {
      tableData = await setPageData()
      await getTotalSuppliers()
    }


    if (!showPending && !showApproved && !showRejected) {
      filteredData = [...tableData]
    } else {
      if (showPending) {
        filteredData = [...filteredData, ...tableData?.filter(row => row.supplierQARole === 'Pending')]
      }
      if (showApproved) {
        filteredData = [...filteredData, ...tableData?.filter(row => row.supplierQARole === 'Approved')]
      }
      if (showRejected) {
        filteredData = [...filteredData, ...tableData?.filter(row => row.supplierQARole === 'Rejected')]
      }
    }

    const cardAcceptData = [...filteredData]?.map(row => {
      const tmpCardData = {};
      masterSupplierColumnsRight.forEach(column => {
        if (column.name === 'isAcceptAchPayments' || column.name === 'isAcceptCheckPayments') {
          tmpCardData[column.name] = row?.payment?.[column.name] || null
        } else {
          tmpCardData[column.name] = row?.cardAcceptance?.[column.name] || null
        }
      })
      return { ...row, ...tmpCardData }
    })
    setPaginatedTableData(cardAcceptData)
  }, [showPending, showApproved, showRejected, page, limit,])


  return (
    <div className="record-container quality-child-record">
      <div className="record-header flex flex-wrap justify-space-between align-center">
        <div className="record-title flex-column flex-sm-row gap-2">
          <h1 className='fw-bold'>Master Suppliers</h1>
          <div className='d-flex flex-wrap'>
            <Checkbox
              checked={showPending}
              onChange={(value, checked) => { setShowPending(checked); setPage(1); setCheckedKeys([]); setCheckedSuppliers([]); }}
            >
              Pending
            </Checkbox>
            <Checkbox
              checked={showApproved}
              onChange={(value, checked) => { setShowApproved(checked); setPage(1); setCheckedKeys([]); setCheckedSuppliers([]); }}
            >
              Approved
            </Checkbox>
            <Checkbox
              checked={showRejected}
              onChange={(value, checked) => { setShowRejected(checked); setPage(1); setCheckedKeys([]); setCheckedSuppliers([]); }}
            >
              Rejected
            </Checkbox>
          </div>
        </div>
        <div className="record-toolbar flex flex-wrap align-center">
          <div className="toolbar-item ps-0 gap-2 flex-wrap">
            <button className="btn-approve ms-0 h-auto pt-2 pb-2" onClick={handleClickApprove}>Approve</button>
            <button className="btn-reject ms-0 h-auto pt-2 pb-2" onClick={handleClickReject}>Reject</button>
          </div>
        </div>
      </div>
      <div className={`record-body ${isLoading ? 'loading' : ''}`}>
        {isLoading && <LoaderComponent />}
        <Table
          virtualized
          autoHeight
          affixHeader={true}
          // data={paginatedData}
          data={paginatedTableData}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortTableData}
        >
          <Column width={50} align="center" fixed>
            <HeaderCell style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Checkbox
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </HeaderCell>
            <CheckCell
              dataKey="id"
              checkedKeys={checkedKeys}
              onChange={handleCheck}
            />
          </Column>
          <Column
            resizable
            sortable
            key='supplierQARole'
            fixed
          >
            <HeaderCell>QA Status</HeaderCell>
            <LinkCell dataKey='supplierQARole' />
          </Column>

          {headerElement}

          {headerElementRight}

          {/**-------Insert Action column */}
          <Column
            width={230}
            fixed="right"
            key="action"
            align="center"
          >
            <HeaderCell>Action</HeaderCell>
            <SelectorCell
              onShowChildren={handleShowChildren}
              onSelectMaster={handleSelectMaster}
              selectedMasterIds={selectedMasterIds}
            />
          </Column>

        </Table>
        <div className="pagination">
          <Pagination
            prev
            next
            first
            last
            showInfo
            maxButtons={5}
            lengthMenu={[
              {
                label: '5',
                value: 5,
              },
              {
                label: '10',
                value: 10,
              },
              {
                label: '25',
                value: 25,
              },
              {
                label: '50',
                value: 50,
              },
            ]}
            displayLength={limit}
            total={totalTableRecords}
            limit={limit}
            activePage={page}
            onChangePage={(event) => { handleChangePage(event) }}
            onChangeLength={handleChangeLimit}
          />
        </div>
      </div>
    </div>
  )
}

export default QualityMasterSuppliersComponent
